import React, {Fragment, useEffect, useState} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input} from 'reactstrap';
import {mapToCssModules} from "reactstrap/lib/utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";

import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";
import {getCurrentOrganisationName} from "../../../utility/UserUtility";

const MySwal = withReactContent(Swal)

const DodajEkipeGrupuModal = (props) => {
    const {
        toggle,
        isOpen,
    } = props;

    const [chosenTeams, setChosenTeams] = useState([]);

    useEffect(() => {

    })


    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                Odaberi ekipe
            </ModalHeader>
            <ModalBody>
                <Select
                    isMulti
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    value={chosenTeams}
                    onChange={(data) => {
                        setChosenTeams(data)
                    }}
                    name='clear'
                    options={props.allTeams.map((oneTeam) => {
                        return {
                            value: oneTeam,
                            label: oneTeam.name
                        }
                    })}
                    isClearable={false}
                />
            </ModalBody>
            <ModalFooter>
                <div className='row justify-content-center text-center' style={{width: "100%"}}>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            props.toggle();
                        }}
                                       type='submit'
                                       color='danger'
                                       className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odustani</span>
                        </Button.Ripple>
                    </div>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            let newAllTeams = props.allTeams.filter((oneTeam) => {
                                let teamNotAdded = true
                                chosenTeams.map((chosenTeam) => {
                                    if (chosenTeam.value._id === oneTeam._id) {
                                        teamNotAdded = false;
                                    }
                                })
                                return teamNotAdded;
                            })
                            let newGroups = props.groups;
                            let newTeams = chosenTeams.map((oneTeam) => {
                                return oneTeam.value;
                            });
                            if (newGroups[props.chosenGroupIndex].teams && newGroups[props.chosenGroupIndex].teams.length > 0) {
                                let oldTeams = [...newGroups[props.chosenGroupIndex].teams];
                                newGroups[props.chosenGroupIndex].teams = [...oldTeams.concat(newTeams)];
                            } else {
                                newGroups[props.chosenGroupIndex].teams = newTeams;
                            }
                            props.setGroups([...newGroups])
                            props.setAllTeams([...newAllTeams])
                            setChosenTeams([]);
                            props.toggle();
                        }} type='submit' color='primary' className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Dodaj ekipe</span>
                        </Button.Ripple>
                    </div>
                </div>
            </ModalFooter>
        </Modal>

    );
}

export default DodajEkipeGrupuModal;